(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-products-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerSelector = '.hb-products-header';
    const chipSelector = '[data-hb-filter-chip]';
    const priceFilterKeys = ['filter.v.price.gte', 'filter.v.price.lte'];
    let activeRequestToken = 0;
    let renderedFilterLocation = window.location.pathname + window.location.search;

    function getCollectionParts(pathname) {
      const parts = pathname.split('/').filter(Boolean);
      const collectionIndex = parts.indexOf('collections');

      if (collectionIndex === -1 || !parts[collectionIndex + 1]) {
        return {
          basePath: '/collections/all',
          tags: [],
        };
      }

      const basePath = `/${parts.slice(0, collectionIndex + 2).join('/')}`;
      const tagSegment = parts.slice(collectionIndex + 2).join('/');
      const tags = tagSegment
        ? tagSegment
            .split('+')
            .map((tag) => decodeURIComponent(tag))
            .filter(Boolean)
        : [];

      return { basePath, tags };
    }

    function getChipFilterUrl(chip) {
      return new URL(chip.dataset.hbFilterUrl || chip.href, window.location.origin);
    }

    function getChipTags(chip) {
      if (chip.dataset.hbFilterTag) return [chip.dataset.hbFilterTag];
      return getCollectionParts(getChipFilterUrl(chip).pathname).tags;
    }

    function hasPriceFilter(url) {
      return priceFilterKeys.some((key) => url.searchParams.has(key));
    }

    function hasSamePriceFilter(currentUrl, targetUrl) {
      return priceFilterKeys.every((key) => currentUrl.searchParams.get(key) === targetUrl.searchParams.get(key));
    }

    function buildFilteredUrl(chip) {
      const currentUrl = new URL(window.location.href);
      const targetUrl = getChipFilterUrl(chip);
      const currentCollection = getCollectionParts(currentUrl.pathname);
      const nextUrl = new URL(currentUrl.href);
      const targetTags = getChipTags(chip);

      if (chip.dataset.hbFilterGroup === 'occasion' && targetTags.length === 0) {
        nextUrl.pathname = currentCollection.basePath === targetUrl.pathname
          ? getAllProductsPath()
          : targetUrl.pathname;
      }

      if (targetTags.length > 0) {
        const isSameOccasion = targetTags.every((tag) => currentCollection.tags.includes(tag));
        const nextTags = isSameOccasion ? [] : targetTags;
        const tagPath = nextTags.map((tag) => encodeURIComponent(tag)).join('+');

        nextUrl.pathname = tagPath ? `${getCollectionParts(targetUrl.pathname).basePath}/${tagPath}` : getCollectionParts(targetUrl.pathname).basePath;
      }

      if (hasPriceFilter(targetUrl)) {
        const shouldClearPrice = hasSamePriceFilter(currentUrl, targetUrl);

        priceFilterKeys.forEach((key) => nextUrl.searchParams.delete(key));

        if (!shouldClearPrice) {
          priceFilterKeys.forEach((key) => {
            const value = targetUrl.searchParams.get(key);
            if (value !== null) nextUrl.searchParams.set(key, value);
          });
        }
      }

      nextUrl.searchParams.delete('page');
      return nextUrl;
    }

    function getAllProductsPath() {
      return new URL(document.querySelector('[data-hb-clear-filters]').href).pathname;
    }

    function updateChipStates(url = new URL(window.location.href)) {
      const activeTags = new Set(getCollectionParts(url.pathname).tags);

      document.querySelectorAll(`${headerSelector} ${chipSelector}`).forEach((chip) => {
        if (!(chip instanceof HTMLAnchorElement)) return;

        const chipUrl = getChipFilterUrl(chip);
        const targetTags = getChipTags(chip);
        const isTagActive = targetTags.length > 0 && targetTags.every((tag) => activeTags.has(tag));
        const isPriceActive = hasPriceFilter(chipUrl) && hasSamePriceFilter(url, chipUrl);
        const isCategoryActive = chip.dataset.hbFilterGroup === 'occasion' && chipUrl.pathname === url.pathname;
        const isActive = isTagActive || isPriceActive || isCategoryActive;

        chip.classList.toggle('hb-products-header__chip--active', isActive);
        if (isActive) {
          chip.setAttribute('aria-current', 'true');
        } else {
          chip.removeAttribute('aria-current');
        }
      });
      document.querySelectorAll('[data-hb-occasion-select]').forEach((select) => {
        const active = document.querySelector('[data-hb-filter-group="occasion"][aria-current]');
        select.value = active ? active.dataset.hbFilterUrl : getAllProductsPath();
      });
      document.querySelectorAll('[data-hb-clear-filters]').forEach((link) => {
        link.closest('.hb-products-header__filter-footer').hidden = url.pathname === getAllProductsPath() && !hasPriceFilter(url);
      });
    }

    function setHeadersApplying(isApplying) {
      document.querySelectorAll(headerSelector).forEach((header) => {
        header.toggleAttribute('data-filters-applying', isApplying);
      });
    }

    function updateHeaderCount() {
      const productCount = document.querySelector('.products-count-wrapper [role="status"]')?.textContent?.trim();
      if (!productCount) return;

      const countMatch = productCount.match(/\d[\d,]*/);

      document.querySelectorAll('[data-hb-products-count]').forEach((countElement) => {
        if (!(countElement instanceof HTMLElement)) return;

        if (!countMatch) {
          countElement.textContent = productCount;
          return;
        }

        const count = countMatch[0];
        countElement.textContent = `Showing ${count} ${count === '1' ? 'product' : 'products'}.`;
      });
    }

    function applyFilterUrl(nextUrl) {
      const facetsForm = document.querySelector('facets-form-component');
      const changesCollection = getCollectionParts(nextUrl.pathname).basePath !== getCollectionParts(window.location.pathname).basePath;
      if (changesCollection || !facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') {
        window.location.assign(nextUrl.toString());
        return;
      }
      renderedFilterLocation = nextUrl.pathname + nextUrl.search;
      activeRequestToken += 1;
      updateChipStates(nextUrl);
      setHeadersApplying(true);
      facetsForm.updateFiltersByURL(nextUrl.toString(), { debounceRender: true });
    }

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const chip = event.target instanceof Element ? event.target.closest(chipSelector) : null;
      if (!(chip instanceof HTMLAnchorElement)) return;
      event.preventDefault();
      applyFilterUrl(buildFilteredUrl(chip));
    });

    document.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-hb-occasion-select]')) return;
      const nextUrl = new URL(window.location.href);
      nextUrl.pathname = new URL(select.value, window.location.origin).pathname;
      nextUrl.searchParams.delete('page');
      applyFilterUrl(nextUrl);
    });

    document.addEventListener('filter:render-start', () => {
      setHeadersApplying(true);
    });

    document.addEventListener('filter:render-complete', () => {
      const requestToken = activeRequestToken;

      requestAnimationFrame(() => {
        if (requestToken !== activeRequestToken) return;
        setHeadersApplying(false);
        updateChipStates();
        updateHeaderCount();
      });
    });

    window.addEventListener('popstate', () => {
      if (window.location.pathname + window.location.search !== renderedFilterLocation) {
        window.location.reload();
        return;
      }
      updateChipStates();
    });

    if (document.querySelector('[data-hb-clear-filters]')) {
      updateChipStates();
      document.querySelectorAll(headerSelector).forEach((header) => header.setAttribute('data-filter-ready', ''));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-prototype-content-page"] && !Shopify.designMode) return;
  try {
    
  function bindContactOptionsPanels() {
    document.querySelectorAll('[data-hb-contact-options-button]').forEach(function(button) {
      if (button.dataset.hbContactOptionsBound === 'true') return;

      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      button.dataset.hbContactOptionsBound = 'true';
      button.addEventListener('click', function() {
        var isOpening = panel.hidden;
        panel.hidden = !isOpening;
        button.setAttribute('aria-expanded', String(isOpening));

        if (isOpening) {
          panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    });
  }

  function bindCorporateOrderPanels() {
    document.querySelectorAll('[data-hb-corporate-order-button]').forEach(function(button) {
      if (button.dataset.hbCorporateOrderBound === 'true') return;

      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      button.dataset.hbCorporateOrderBound = 'true';
      button.addEventListener('click', function() {
        var isOpening = panel.hidden;
        panel.hidden = !isOpening;
        button.setAttribute('aria-expanded', String(isOpening));

        if (isOpening) {
          panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    });
  }

  bindContactOptionsPanels();
  bindCorporateOrderPanels();
  document.addEventListener('shopify:section:load', bindContactOptionsPanels);
  document.addEventListener('shopify:section:load', bindCorporateOrderPanels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
